module.exports = __webpack_public_path__ + "img/9.8ec35c8a.png";